import { utils } from '@deeptrue-frontend/ui';
import React from 'react';
import {
  localization,
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from 'survey-react-ui';

import { ElementFactory, Question, Serializer, SvgRegistry } from 'survey-core';
import ReactDOMServer from 'react-dom/server';
import { ReactComponent as WidgetIcon } from 'assets/icons/widget.svg';

export const registerAssetConsumer = () => {
  // @ts-ignore
  const AssetConsumer = utils.survey.widgets.AssetConsumer.widget;

  class QuestionAssetconsumerModel extends Question {
    getType() {
      return 'dtassetconsumerv2';
    }
    get assetconsumerType() {
      return this.getPropertyValue('assetconsumerType');
    }
    set assetconsumerType(val) {
      this.setPropertyValue('assetconsumerType', val);
    }
  }

  // set display title for question type
  localization.getLocale('').qt.dtassetconsumerv2 = 'dt Asset Consumer';

  const svg = ReactDOMServer.renderToString(<WidgetIcon />);
  SvgRegistry.registerIconFromSvg('dtassetconsumerv2', svg);

  // this serializes the class into JSON
  Serializer.addClass(
    'dtassetconsumerv2',
    [
      {
        name: 'assetconsumerType',
      },
    ],
    function () {
      return new QuestionAssetconsumerModel('');
    },
    'question'
  );

  SurveyQuestionEditorDefinition.definition.assetconsumer = {
    properties: [{ name: 'assetconsumerType', tab: 'layout' }],
  };

  ElementFactory.Instance.registerElement('dtassetconsumerv2', (name) => {
    return new QuestionAssetconsumerModel(name);
  });

  class SurveyQuestionAssetconsumer extends SurveyQuestionElementBase {
    constructor(props: any) {
      super(props);
      this.state = { value: this.question.value };
    }
    get question() {
      return this.questionBase;
    }
    get value() {
      return this.question.value;
    }

    get type() {
      // @ts-ignore KRZYŚ
      return this.question.assetconsumerType;
    }
    handleAssetconsumerChange = (data: any) => {
      this.question.value = data;
    };

    // support readOnly and designMode
    get style() {
      return this.question.getPropertyValue('readOnly') ||
        this.question.isDesignMode
        ? {
            pointerEvents: 'none',
          }
        : undefined;
    }

    renderElement() {
      return <AssetConsumer question={this.question} />;
    }
  }
  ReactQuestionFactory.Instance.registerQuestion(
    'dtassetconsumerv2',
    (props: any) => {
      return React.createElement(SurveyQuestionAssetconsumer, props);
    }
  );

  Serializer.addProperties('dtassetconsumerv2', [
    {
      name: 'assetUploadName:string',
      category: 'Asset Consumer',
    },
    {
      name: 'emptyImg:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'image not avaliable in selected language',
    },
    {
      name: 'emptyVid:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'video not avaliable in selected language',
    },
    {
      name: 'titleVideo:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Here you can see an video with an advertisement.',
    },
    {
      name: 'titleImage:string',
      category: 'Locales',
      isLocalizable: true,
      default: 'Here you can watch a image with an advertisement.',
    },
  ]);

  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'dtassetconsumerv2';
    },
    getJSON: function () {
      return { type: 'dtassetconsumerv2' };
    },
  });
};
